import { render, staticRenderFns } from "./messageTemplatePanel.vue?vue&type=template&id=6a6a813a&scoped=true&"
import script from "./messageTemplatePanel.vue?vue&type=script&lang=js&"
export * from "./messageTemplatePanel.vue?vue&type=script&lang=js&"
import style0 from "./messageTemplatePanel.vue?vue&type=style&index=0&id=6a6a813a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a6a813a",
  null
  
)

export default component.exports